'use strict';

const AdUnitLazyLoader = {
  load: () =>
    $('.ad-widget iframe').attr('src', function() {
      return $(this).attr('data-src');
    }),
};

window.AdUnitLazyLoader = AdUnitLazyLoader;
module.exports = AdUnitLazyLoader;



// WEBPACK FOOTER //
// ./modules/ad_unit/frontend/ad_unit_lazy_loader.js